import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/common.json";
import pt from "./locales/pt/common.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { pt: { common: pt }, en: { common: en } },
    fallbackLng: "pt",
    supportedLngs: ["pt", "en"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "path", "navigator"],
      caches: ["localStorage"],
      lookupFromPathIndex: 0,
    },
  });

export default i18n;
